export const Video = ({ size = 24 }: { size?: number }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4ZM3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5ZM16.1061 12L9.25 16.2629L9.25 7.73712L16.1061 12ZM16.6342 11.1508C17.2635 11.542 17.2635 12.458 16.6342 12.8492L9.77802 17.1121C9.11189 17.5263 8.25 17.0473 8.25 16.2629L8.25 7.73712C8.25 6.95273 9.11189 6.47371 9.77802 6.88789L16.6342 11.1508Z"
        fill="#4C566A"
      />
    </svg>
  )
}
